export default __webpack_public_path__ + "static/media/screen3.dfcc3789.png";